export const cookiesFunc = {
  methods: {
    getCookieValue(cookiename) {
      return (
        document.cookie
          .match("(^|;)\\s*" + cookiename + "\\s*=\\s*([^;]+)")
          ?.pop() || ""
      );
    },
    eraseCookie(cookiename) {
      document.cookie =
        cookiename + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
    setCookie(cName, cValue, expDays) {
      if (expDays) {
        let date = new Date();
        date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
        return;
      }

      document.cookie = cName + "=" + cValue + "; " + "; path=/";
    },
    saveCookieCfgSteps(page_id) {
      const resume = this.resumeData;
      const obj = {
        modelid: resume.modelid,
        engine: resume.selectedEngine,
        version: resume.versionID,
        colext: resume.configSelected?.dsgExt?.colorid,
        colint: resume.configSelected?.dsgInt?.colorid,
      };

      let params = "/?";
      for (const [key, value] of Object.entries(obj)) {
        if (value) {
          const id = this.$route.matched?.[1].props?.default.id;

          if (page_id > id) break;

          params = params + `${key}=${value}&`;
        } else {
          break;
        }
      }
      this.setCookie("cfg_app_params", params);
    },
  },
};
